var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYmsLogoModified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 24,
    viewBox: "0 0 97 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6941 1.18182L41.6522 15.2869V23H46.2331V15.2869L54.1912 1.18182H49.0243L44.0492 10.5781H43.8361L38.861 1.18182H33.6941ZM54.7108 1.18182V23H59.1852V8.74574H59.3663L65.0126 22.8935H68.0595L73.7058 8.79901H73.8869V23H78.3613V1.18182H72.6724L66.6639 15.8409H66.4082L60.3997 1.18182H54.7108ZM91.9979 7.45668H96.419C96.3551 3.56818 93.1591 0.883522 88.3011 0.883522C83.5178 0.883522 80.0128 3.52557 80.0341 7.48864C80.0234 10.706 82.2926 12.549 85.9787 13.4332L88.3544 14.0298C90.7301 14.6051 92.0511 15.2869 92.0618 16.7571C92.0511 18.3551 90.5384 19.4418 88.1946 19.4418C85.7976 19.4418 84.0717 18.3338 83.9226 16.1499H79.4588C79.576 20.8693 82.9531 23.3089 88.2479 23.3089C93.5746 23.3089 96.7067 20.7628 96.7173 16.7678C96.7067 13.1349 93.9688 11.2067 90.1761 10.3544L88.2159 9.88565C86.3196 9.44886 84.7322 8.74574 84.7642 7.17969C84.7642 5.77344 86.0107 4.74006 88.2692 4.74006C90.4744 4.74006 91.8274 5.74148 91.9979 7.45668Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 1H23.2741L2.75 23H7.53249L25.6667 3.5619V1Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.501 1L0 15.1758V20.25L18.3333 1H13.501Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64707 1L0 5.05205V10.1667L8.25 1H3.64707Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 8.33331L11.9167 23H16.8409L25.6667 13.586V8.33331Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 19.3333L22 23H25.6667V19.3333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYmsLogoModified);
export default __webpack_public_path__ + "static/media/yms-logo-modified.810ae9245950c927a7b6ed2c86d0bc16.svg";
export { ForwardRef as ReactComponent };